"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserListComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const user_service_1 = require("./user.service");
const users_service_1 = require("./users.service");
const organizations_service_1 = require("./organizations.service");
const notification_service_1 = require("./notification.service");
const permission_service_1 = require("./permission.service");
const roles_service_1 = require("./roles.service");
let UserListComponent = class UserListComponent {
    constructor(_talk, _admin, _cd, _user, _users, _permission, _roles, _organization) {
        this._talk = _talk;
        this._admin = _admin;
        this._cd = _cd;
        this._user = _user;
        this._users = _users;
        this._permission = _permission;
        this._roles = _roles;
        this._organization = _organization;
        this.sortDir = '+';
        this.sortBy = '+email';
        this.organizations = [];
        this.userPage = 1;
        this.toEmail = true;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.user = yield this._user.get();
            if (typeof this.user.organization === 'number') {
                this.user.organization = this._organization.getOrgById(this.user.organization);
            }
            this.user.orgName = this.user.organization.displayName;
        });
    }
    setSort(sortBy) {
        this.sortDir = this.sortDir === '+' ? '-' : '+';
        this.sortBy = `${this.sortDir}${sortBy}`;
    }
};
exports.UserListComponent = UserListComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], UserListComponent.prototype, "users", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], UserListComponent.prototype, "permission", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], UserListComponent.prototype, "roles", void 0);
exports.UserListComponent = UserListComponent = __decorate([
    (0, core_1.Component)({
        selector: 'user-list',
        templateUrl: 'app/user-list.component.html',
        styleUrls: ['styles/admin.component.css']
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        user_service_1.UserService,
        users_service_1.UsersService,
        permission_service_1.PermissionService,
        roles_service_1.RolesService,
        organizations_service_1.OrganizationsService])
], UserListComponent);
//# sourceMappingURL=user-list.component.js.map